/**
 * API Categories Configuration
 * 
 * Categorization structure for all AI servers
 * 
 * @fileoverview API categories and metadata
 */

/**
 * API Categories by Server
 */
export const API_CATEGORIES = {
  chinese: [
    { id: 'grammar', name: 'Grammar & Writing', count: 5 },
    { id: 'pinyin', name: 'Pinyin & Pronunciation', count: 4 },
    { id: 'character', name: 'Character & Radical', count: 6 },
    { id: 'translation', name: 'Translation', count: 3 },
    { id: 'analysis', name: 'Text Analysis', count: 4 },
    { id: 'resources', name: 'Learning Resources', count: 10 },
  ],
  english: [
    { id: 'grammar', name: 'Grammar & Syntax', count: 15 },
    { id: 'vocabulary', name: 'Vocabulary', count: 20 },
    { id: 'reading', name: 'Reading Comprehension', count: 12 },
    { id: 'writing', name: 'Writing Tools', count: 18 },
    { id: 'pronunciation', name: 'Pronunciation', count: 8 },
    { id: 'assessments', name: 'Assessments', count: 12 },
  ],
  maths: [
    { id: 'solving', name: 'Problem Solving', count: 15 },
    { id: 'steps', name: 'Step Solutions', count: 12 },
    { id: 'equations', name: 'Equation Handling', count: 10 },
    { id: 'graphing', name: 'Graphing', count: 8 },
    { id: 'statistics', name: 'Statistics', count: 10 },
    { id: 'geometry', name: 'Geometry', count: 13 },
  ],
  myclass: [
    { id: 'content', name: 'Content Generation', count: 12 },
    { id: 'assessment', name: 'Assessment', count: 10 },
    { id: 'analytics', name: 'Analytics', count: 8 },
    { id: 'management', name: 'Student Management', count: 15 },
    { id: 'curriculum', name: 'Curriculum', count: 5 },
  ],
};

/**
 * Get categories for a server
 * @param {string} server - Server type
 * @returns {Object[]} Categories
 */
export function getCategoriesForServer(server) {
  return API_CATEGORIES[server] || [];
}

/**
 * Get all unique categories across all servers
 * @returns {string[]} Unique category names
 */
export function getAllCategories() {
  const categories = new Set();
  Object.values(API_CATEGORIES).forEach((serverCategories) => {
    serverCategories.forEach((cat) => {
      categories.add(cat.name);
    });
  });
  return Array.from(categories);
}

